<template>
  <div class="row py-5" id="beneficios">
    <div class="col-12">
      <div class="container-xxl">
        <div class="">

          <div class="beneficios ">
            <div class="left">
              <h2>Benefícios para os <strong>Renders</strong></h2>
              <div class="benefits-buttons" v-for="(item,i) in benefitsName" :key="i">
                <div class="ben-button" @click="selectBenefit"><p :id="i">{{ item.title }}</p></div>
              </div>
            </div>
            <div class="right">
              <p>Os benefícios colaboram com a nossa qualidade de vida por atenderem diretamente necessidades básicas como saúde, alimentação, transporte e bem-estar.<br>
              Conheça o nosso Pacote de Benefícios:</p>
              <div class="quadro-beneficios" v-if="benefitTitleSelected">
                <div><h4>{{ benefitTitleSelected }}</h4></div>
                <div class="cards-benefi" >
                  <div v-for="(item,i) in benefitSelected">
                    <img :src="require(`@/assets/images/icons/${item.image}`)" alt="beneficios">
                    <p>{{ item.name }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'Benefits',

    data(){
      return {
        benefitTitleSelected:'Saúde e bem estar',
        benefitSelected:[
        {
          "id":0,
          "image":"item(20).svg",
          "name":"Assistência médica",
        },
        {
          "id":0,
          "image":"item(19).svg",
          "name":"Assistência odontológica",
        },
        {
          "id":0,
          "image":"item(18).svg",
          "name":"Desconto em medicamentos",
        },
        {
          "id":0,
          "image":"item(17).svg",
          "name":"Seguro de vida",
        },],
      }
    },

    computed: {
      benefitsName(){
        return this.$store.state.benefitsName;
      },

      benefitsCards(){
        return this.$store.state.benefitsCards;
      }
    },

    methods: {
      selectBenefit(){
        let benefitIdSelected = event.target.id;
        this.benefitTitleSelected = event.target.innerHTML;
        const benefits = this.$store.state.benefitsCards;
        this.benefitSelected = benefits.filter((item) =>{
          if(item.id == benefitIdSelected ){
            return item
          }
        });
        return this.benefitSelected;
      },
    }
  }
</script>

<style lang="scss" scoped>
  #beneficios{
    background-color: #f5f5f5;
    padding: 0 50px;
    @media screen and (max-width: 1100px) {
      padding: 0;
    }
  }

  .beneficios{
    display: flex;
    justify-content: center;

    .left{
      width: 350px;
      padding: 10px 30px 10px 0;
      flex-shrink: 0;

      @include media-breakpoint-down(md){
        width: 100%;
      }

      h2{
        font-size: 36px;
        color: #0A1D6F;
        font-weight: 400;
        strong{
          font-weight: bold;
          color: #00CFD9;
        }
      }

      .benefits-buttons{
        display: flex;
        flex-direction: column;

        .ben-button{
          border: 2px solid #00CFD9;
          border-radius: 28px;
          color: #00CFD9;
          text-align: center;
          margin-top: 20px;
          cursor: pointer;

          p{
            margin: auto;
            padding: 12px 20px;
            color: #00CFD9;
          }

          &:hover{
            background: #00CFD9;
            p{
              color: #0A1D6F;
            }
          }
        }
      }
    }

    .right{
      flex-grow: 1;
      padding: 25px 0 25px 25px;

      p{
        color: #0A1D6F;
      }

      .quadro-beneficios{
        width: 100%;
        height: auto;
        border: 2px solid #00CFD9;
        border-radius: 8px;
        margin: auto;
        text-align: center;
        h4{
          color: #00CFD9;
          font-weight: bold;
          margin-top: 30px;
        }

        .cards-benefi{
          display: flex;
          justify-content: space-evenly;
          margin-top: 25px;
          img{
            width: 120px;
          }
          p{
            width: 150px;
            color: #0A1D6F;
            margin: 20px auto 20px auto;
            font-weight: bold;
          }
        }

      }
    }

    @include media-breakpoint-down(md) {
      flex-wrap: wrap;

      .right{
        max-width: 500px;

        .quadro-beneficios{
          width: 100%;
        }
      }
    }

    @include media-breakpoint-down(sm) {
      .right{
        padding: 10px 5px;
        .quadro-beneficios{
          height: auto;
          .cards-benefi{
            flex-wrap: wrap;
          }
        }
      }
    }
  }
</style>